import { ProjectDataProps } from "../Components/common/types";
import test1 from "../assets/images/test1.png";
import test2 from "../assets/images/test2.jpg";
import testVideo from "../assets/videos/testVideo.mp4";

export const projects: ProjectDataProps[] = [
  {
    name: "Krazy Knot",
    dateStarted: 1674432000000,
    type: { value: 'design', label: 'Design' },
    id: "1",
    description: "Hello this is Krazy Knot Project, happy pics",
    galleryData: {
      imgData: [
        {
          id: "1",
          src: test1,
          alt: "Test1",
          description: "Yes test description",
          fileSignature: "",
          publicId: "",
          isCover: false,
          mimetype: ""
        },
      ],
      vidData: []
    },
    links: {
      liveDemo: "",
      github: ""
    },
    endDate: 0,
    isOngoing: true
  },
  {
    id: "2",
    name: "Weather Zen",
    dateStarted: 1732116081429,
    type: { value: 'mobile', label: 'Mobile' },
    description: "A weather app with unique visualizations, build in Flutter with Firebase that powers the backend and runs on both android and iOS.",
    galleryData: {
      imgData: [
        {
          id: "1",
          src: test1,
          alt: "Test1",
          description: "This is an image description",
          fileSignature: "",
          publicId: "",
          isCover: false,
          mimetype: ""
        },
        {
          id: "2",
          src: test2,
          alt: "Test2",
          description: "This is an image description",
          fileSignature: "",
          publicId: "",
          isCover: false,
          mimetype: ""
        },
      ],
      vidData: [
        {
          id: "1",
          src: testVideo,
          mimetype: "video/mp4",
          description: "This is a video description",
          fileName: "",
          fileSignature: "",
          publicId: "",
          isCover: false
        },
      ],
    },
    links: {
      liveDemo: "https://example.com/weatherzen",
      github: "https://github.com/example/weatherzen",
    },
    endDate: 0,
    isOngoing: true
  },
  {
    name: "Anim",
    dateStarted: 1674432000000,
    type: { value: 'web', label: 'Web' },
    id: "3",
    description: "",
    galleryData: {
      imgData: [],
      vidData: []
    },
    links: {
      liveDemo: "",
      github: ""
    },
    endDate: 0,
    isOngoing: false
  },
  {
    name: "Dark Art Gallery",
    dateStarted: 1732116081429,
    type: { value: 'web', label: 'Web' },
    id: "4",
    description: "",
    galleryData: {
      imgData: [],
      vidData: []
    },
    links: {
      liveDemo: "",
      github: ""
    },
    endDate: 0,
    isOngoing: false
  },
  {
    name: "Rain Hour",
    dateStarted: 1674432000000,
    type: { value: 'web', label: 'Web' },
    id: "5",
    description: "",
    galleryData: {
      imgData: [],
      vidData: []
    },
    links: {
      liveDemo: "",
      github: ""
    },
    endDate: 0,
    isOngoing: false
  },
];

export const sideProjects: ProjectDataProps[] = [
  // {
  //   name: "E-commerce",
  //   dateStarted: 1674432000000,
  //   type: { value: 'design', label: 'Design' },
  //   id: "1",
  //   description: "",
  //   galleryData: {
  //     imgData: [],
  //     vidData: []
  //   },
  //   links: {
  //     liveDemo: "",
  //     github: ""
  //   },
  //   endDate: 0,
  //   isOngoing: false
  // },
  // {
  //   name: "Read PDF",
  //   dateStarted: 1732116081429,
  //   type: { value: 'mobile', label: 'Mobile' },
  //   id: "2",
  //   description: "",
  //   galleryData: {
  //     imgData: [],
  //     vidData: []
  //   },
  //   links: {
  //     liveDemo: "",
  //     github: ""
  //   },
  //   endDate: 0,
  //   isOngoing: false
  // },
  // {
  //   name: "Inventory System",
  //   dateStarted: 1674432000000,
  //   type: { value: 'web', label: 'Web' },
  //   id: "3",
  //   description: "",
  //   galleryData: {
  //     imgData: [],
  //     vidData: []
  //   },
  //   links: {
  //     liveDemo: "",
  //     github: ""
  //   },
  //   endDate: 0,
  //   isOngoing: false
  // },
  // {
  //   name: "Anim Zen",
  //   dateStarted: 1732116081429,
  //   type: { value: 'design', label: 'Design' },
  //   id: "4",
  //   description: "",
  //   galleryData: {
  //     imgData: [],
  //     vidData: []
  //   },
  //   links: {
  //     liveDemo: "",
  //     github: ""
  //   },
  //   endDate: 0,
  //   isOngoing: false
  // },
  // {
  //   name: "Easy Schedular",
  //   dateStarted: 1674432000000,
  //   type: { value: 'mobile', label: 'Mobile' },
  //   id: "5",
  //   description: "",
  //   galleryData: {
  //     imgData: [],
  //     vidData: []
  //   },
  //   links: {
  //     liveDemo: "",
  //     github: ""
  //   },
  //   endDate: 0,
  //   isOngoing: false
  // },
  // {
  //   name: "Audo Lato",
  //   dateStarted: 1732116081429,
  //   type: { value: 'design', label: 'Design' },
  //   id: "6",
  //   description: "",
  //   galleryData: {
  //     imgData: [],
  //     vidData: []
  //   },
  //   links: {
  //     liveDemo: "",
  //     github: ""
  //   },
  //   endDate: 0,
  //   isOngoing: false
  // },
];
